<script setup>
import DealersAndDistributorsTabs from '@/components/DealersAndDistributorsTabs.vue';
import { useBlockSafe } from '@/composables/useBlockSafe';

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
const { id, backgroundColor, spacingTop, spacingBottom, items, hasItems } =
  useBlockSafe(props.data);
</script>
<template>
  <section
    v-if="hasItems"
    :id="id"
    class="section"
    :class="[
      backgroundColor ? `bg-${backgroundColor}` : '',
      spacingTop ? `section--top-${spacingTop}` : 'section--top-xl',
      spacingBottom ? `section--bottom-${spacingBottom}` : 'section--bottom-xl',
    ]"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
  >
    <div class="container">
      <DealersAndDistributorsTabs
        :data="items"
        :background-color="backgroundColor"
        :view="'default'"
      />
    </div>
  </section>
</template>

<style scoped lang="scss"></style>
